import { Button } from "./Button";

export function Pagination({
  page,
  totalPages,
  onPageChange,
  capped = false,
}: {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  capped?: boolean;
}) {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="mt-4 flex items-center justify-between text-sm text-foreground">
      <span>
        Page {page} of {totalPages}
        {capped && "+"}
      </span>

      <div className="flex gap-2">
        <Button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          variant="secondary"
        >
          Previous
        </Button>
        <Button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          variant="secondary"
        >
          Next
        </Button>
      </div>
    </div>
  );
}
